import React from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import useWorkflowPerms from '../components/workflow/useWorkflowPerms';
import { EngagementName } from '../components/workflow/CoverageDisplay';

// Engagement Status Change — list page (docs/modules/workflow-esc.md).
// The reviewed route to a manual engagements.status change: the workflows set
// the status automatically (created → first submission → QC35 Form approval), so
// anything else — Discontinued, or correcting a wrong one —
// comes through here and QM approves it.
const WorkflowEsc = () => {
  const { canSubmit } = useWorkflowPerms('esc');
  return (
    <WorkflowListShell
      title="Engagement Status Change"
      subtitle="Engagement status change requests."
      newTo="/workflow/esc/new"
      canCreate={canSubmit}
      apiPath="/api/workflow/esc"
      rowTo={(r) => `/workflow/esc/${r.id}`}
      searchPlaceholder="Search request no, engagement or requester…"
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      columns={[
        { key: 'requestNo', label: 'Request', sortKey: 'requestNo', render: (r) => <span className="font-medium text-blue-700">{r.requestNo}</span> },
        { key: 'engagementName', label: 'Engagement', sortKey: 'engagement', render: (r) => <EngagementName name={r.engagementName} now={r.engagementNameNow} serviceDescription={r.serviceDescription} /> },
        { key: 'change', label: 'Change', render: (r) => (
          <span className="whitespace-nowrap text-slate-600">
            {r.currentStatus} <span className="text-slate-400">→</span> <span className="font-medium text-slate-900">{r.requestedStatus}</span>
          </span>
        ) },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'requester', label: 'Requested By', render: (r) => <span className="text-slate-500">{r.requesterEmail}</span> },
      ]}
    />
  );
};

export default WorkflowEsc;
